<app-loader *ngIf="isLoadingNotes" [zIndex]="10"></app-loader>
<section *ngIf="!isLoadingNotes">

  <div class="notes">
    <h2 class="notes-title">Notes</h2>
    <div class="notes-right">

      <div class="col-xs-12">
            <span class="filter-btn"
                  *ngIf="allNotesCount === 1"
                  (click)="setFilterToAll()"
                  [class]="{'active-filter': filterSetToAll}"
                  yp-e2e-id="notes-filter-all">
              {{allNotesCount}} note found
            </span>

        <span class="filter-btn"
              *ngIf="allNotesCount !== 1"
              (click)="setFilterToAll()"
              [class]="{'active-filter': filterSetToAll}"
              yp-e2e-id="notes-filter-all">
              {{allNotesCount}} notes found
            </span>

        <span class="filter-btn"
              *ngIf="propertyNotesCount === 1"
              (click)="setFilterToPropertyNotes()"
              [class]="{'active-filter': filterSetToPropertyNotes}"
              yp-e2e-id="notes-filter-property-notes">
          {{propertyNotesCount}} property note
            </span>

        <span class="filter-btn"
              *ngIf="propertyNotesCount !== 1"
              (click)="setFilterToPropertyNotes()"
              [class]="{'active-filter': filterSetToPropertyNotes}"
              yp-e2e-id="notes-filter-property-notes">
          {{propertyNotesCount}} property notes
            </span>

        <span class="filter-btn"
              *ngIf="sellerNotesCount === 1"
              (click)="setFilterToSellerNotes()"
              [class]="{'active-filter': filterSetToSellerNotes}"
              yp-e2e-id="notes-filter-seller-notes">
          {{sellerNotesCount}} seller note
            </span>

        <span class="filter-btn"
              *ngIf="sellerNotesCount !== 1"
              (click)="setFilterToSellerNotes()"
              [class]="{'active-filter': filterSetToSellerNotes}"
              yp-e2e-id="notes-filter-seller-notes">
          {{sellerNotesCount}} seller notes
            </span>
      </div>
    </div>
  </div>

  <button class="button button-primary button-sm new-note-btn" yp-e2e-id="add-new-note"
          (click)="showAddNotesForm = true">
    <span>New note</span>
  </button>
  <form [formGroup]="noteForm"
        (ngSubmit)="submit()"
        (keydown.enter)="$event.preventDefault()" *ngIf="showAddNotesForm">
    <span class="text-area-label">Enter note:</span>
    <textarea name="new-note" class="text-area" yp-e2e-id="note-text" formControlName="note"></textarea>

    <button class="button button-primary button-sm pull-right" yp-e2e-id="note-save" type="submit">
      <span>Save</span>
    </button>
    <button type="button" class="button-default button button-sm cancel-btn" yp-e2e-id="note-save-cancel"
            (click)="showAddNotesForm = false">
      <span>Cancel</span>
    </button>
  </form>

  <div class="messages--thread">
    <div class="messages--thread--message-container__note" *ngFor="let item of notes">
      <div class="thread--message" yp-e2e-id="full-notes-details">
        <div class="note-container">
          <div class="img-container">
            <img *ngIf="item.author.photoUrl" src="{{item.author.photoUrl}}"
                 class="img-circle thread--message--thumbnail__note">
            <i *ngIf="!item.author?.photoUrl"
               class="far fa-user-circle img-placeholder"></i>
          </div>
          <div class="note-body">
            <div class="note-author">
              <h5 class="user">{{item.author ? item.author.name : "Yopa system note"}}</h5>
              <span *ngIf="item.task_name" class="thread--message--task-name"
                    yp-e2e-class="property-note-type"><small>Task:</small> <small>{{item.task_name}} </small></span>
              <span *ngIf="item.task?.event" class="thread--message--task-name"
                    yp-e2e-class="property-note-type"><small> Task:</small> <small> {{item.task.event.name}} </small></span>
              <span *ngIf="item.noteable_type" class="thread--message--task-name"
                    yp-e2e-class="property-note-type"><small> {{item.noteable_type}}</small></span>
              <span *ngIf="item.noteableType" class="thread--message--task-name"
                    yp-e2e-class="property-note-type"><small> {{displayStrategy(item)}}</small></span>
              <span *ngIf="item.type === 'conveyancing'" class="thread--message--task-name"
                    yp-e2e-class="property-note-type"><small>Conveyancing referral</small></span>

              <span *ngIf="item.subject" class="thread--message--task-name" yp-e2e-class="property-note-type"><small>Related customer: </small>
                        <a href="/yopaplus/users/{{item.subject.id}}/detail/history" target="_blank">
                            <small>{{item.subject.name}}</small>
                        </a>
                    </span>
              <span class="thread--message--date">{{formatDate(item)}} at {{formatTime(item)}}</span>
            </div>
            <div class="note-text">
              <p class="thread--message--body" style="white-space:pre-line;" yp-e2e-id="note-text">
                {{item.note}}</p>
            </div>
          </div>
        </div>
        <label class="stars">
          <i class="fas fa-star" [class]="{'selected': item.is_sticky === 1 || item.isSticky === 1 || item.is_sticky === true || item.isSticky === true}"
             (click)="updateStickyNote(item)"
             yp-e2e-id="note-star"></i>
        </label>
      </div>
    </div>
  </div>
</section>
